export default {
    "Searchbar": {
        "searchPlaceHolder": "데모 검색"
    },
    "NaviTree": {
        "Home": "홈",
        "Quick Start": "빠른 시작",
        "Demo Gallery": "특징",
        "Feature Samples": "예",
        "Performance Test": "성능 테스트",
        "Row Template Designer": "행 템플릿 디자이너"
    },
    "QuickStartPage": {
        "steps": "단계"
    },
    "DemoPage": {
        "Description": "이 단계별 자습서를 사용하여 Spread의 모든 면을 살펴보십시오. 왼쪽에서 메뉴를 선택하여 다양한 데모를 볼 수 있습니다.",
        "Run": "실행",
        "SourceCode": "원본 코드",
        "Download": "다운로드",
        "html": "Html",
        "JavaScript": "JavaScript",
        "css": "CSS",
        "resource": "리소스",
        "desiriptionTabDesc": "설명"
    },
    "SourceTab": {
        "Example": "샘플",
        "SourceCode": "코드"
    },
    "Footer": {
        "Copyright": "©2018 GrapeCity Inc. All Rights Reserved."
    },
    "App": {
        "DownloadTrial": "평가판 다운로드",
        "OpenInNewWindow": "새 창에서 열기",
        "NavigateToPreviousDemo": "이전 데모 탐색",
        "NavigateToNextDemo": "다음 데모 탐색"
    },
    "homeSections": [{
        "htmlPartialPage": "<section class=\"home-intro\">\r\n    <h1><%= header %></h1>\r\n    <div class=\"wrapper\">\r\n        <div class=\"padder clearfix\">\r\n            <p class=\"lead\">\r\n                <%= description %>\r\n            </p>\r\n            <ul>\r\n                <li>\r\n                    <%= detail1 %>\r\n                </li>\r\n                <li>\r\n                    <%= detail2 %>\r\n                </li>\r\n                <li>\r\n                    <%= detail3 %>\r\n                </li>\r\n                <li>\r\n                    <%= detail4 %>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n    </div>\r\n</section>",
        "intlResources": {
            "header": "SpreadJS Spread.Sheets Demo입니다!",
            "description": "자체 응용 프로그램에서 Spread.Sheets를 사용할 수 있는 여러 가지 방법을 살펴봅니다. 다음과 같은 다양한 일반적인 사용 사례가 있습니다.",
            "detail1": "완전한 기능을 갖춘 스프레드시트",
            "detail2": "고급 눈금",
            "detail3": "양식 입력",
            "detail4": "대시보드"
        }
    }, {
        "title": "자주 사용되는 기능으로는 완전한 수식 엔진, 정렬, 필터링, 입력 제어, 스파크라인, 기본 Excel 입력/출력 등이 있습니다.",
        "description": "왼쪽 메뉴에서 예 또는 데모 중 하나를 선택하여 Spread.Sheets를 사용할 수 있는 방법을 지금 알아보십시오!"
    }],
    "quickStart": {
        "step1": [{
            "title": "Spread 얻기",
            "description": "Spread.Sheets는 SpreadJS 제품군에 속하는 스프레드시트 컴포넌트입니다. 자주 사용되는 기능으로는 수식 엔진, 정렬, 필터링, 입력 제어, 스파크라인 및 Excel 입력/출력이 있습니다. 다음 단계에 따라 Spread를 프로젝트에 추가하고, 데이터에 바인딩하고, 모양을 설정합니다.",
            "steps": [{
                "key": "reference",
                "description": " Spread.Sheets는 종속성이 없습니다. gc.spread.sheets.x.xx.xxxxx.x.css, gc.spread.sheets.all.x.xx.xxxxx.x.min.js 파일이 필요합니다.",
                "value": "<link rel=\"styleSheet\" href=\"gc.spread.sheets.xx.x.x.css\" />\r\n<script src=\"gc.spread.sheets.all.xx.x.x.min.js\" type=\"text/javascript\"></script>\r\n<script src=\"gc.spread.sheets.resources.ko.xx.x.x.min.js\" type=\"text/javascript\"></script>"
            }, {
                "key": "htmlBody",
                "description": " DOM 요소를 페이지 본문에 컨테이너로 포함합니다.",
                "value": "<div id=\"ss\" style=\"width:100%; height:360px;border: 1px solid gray;\"></div>"
            }, {
                "key": "inlineScript",
                "description": " Spread 컴포넌트는 new GC.Spread.Sheets.Workbook(document.getElementById('ss'), { sheetCount: 1 })으로 초기화됩니다.",
                "value": "window.onload = function () {\r\n    var spread = new GC.Spread.Sheets.Workbook(document.getElementById('ss'), { sheetCount: 1 });\r\n};"
            }]
        }, {
            "title": "데이터 바인딩",
            "description": "이 단계에서 데이터를 Spread.Sheets에 추가합니다. 데이터는 데이터 원본을 기반으로 하여 셀에 표시됩니다.",
            "steps": [{
                "key": "inlineScript",
                "description": " Spread.Sheets에 데이터를 쉽게 추가할 수 있습니다. getSheet 메서드를 사용하여 작업 중인 시트를 가져옵니다. \"new GC.Spread.Sheets.Bindings.CellBindingSource(person);\"를 사용하여 셀 바인딩 원본을 설정합니다. 그런 다음 setBindPath 메서드를 사용하여 지정된 시트 영역에서 지정된 셀의 바인딩 경로를 설정합니다. 그런 다음 setDataSource 메서드를 사용하여 시트의 데이터 원본을 설정합니다.",
                "value": "var sheet = spread.getSheet(0);\r\nvar person = { name: 'Wang feng', age: 25, gender: 'Male', address: { postcode: '710075' } };\r\nvar source = new GC.Spread.Sheets.Bindings.CellBindingSource(person);\r\nsheet.setBindingPath(2, 2, 'name');\r\nsheet.setBindingPath(3, 2, 'age');\r\nsheet.setBindingPath(4, 2, 'gender');\r\nsheet.setBindingPath(5, 2, 'address.postcode');\r\nsheet.setDataSource(source);"
            }]
        }, {
            "title": "스타일 설정",
            "description": "초기화 작업과 데이터 바인딩 후에는 데이터가 Spread.Sheets에 표시됩니다. 이 단계에서 사용자 카드를 더 매력적으로 만들고 표준화하기 위해 시트의 스타일을 설정합니다.",
            "steps": [{
                "key": "inlineScript",
                "description": " 이전 섹션에서 각 데이터 항목의 스타일을 설정합니다. 이렇게 하면 데이터를 더 쉽게 보고 더 유용하게 사용할 수 있습니다. Spread.Sheets에 대한 해당 이름의 '사용자 카드' 제목을 추가하고 addSpan 메서드를 사용하여 셀을 확장합니다. 그런 다음 지정된 열의 너비를 변경합니다. backColor, foreColor, border, horizontalAlign 등과 같이 사용자 카드의 스타일을 추가합니다.",
                "value": "sheet.getCell(2,1).text(\"Name\");\r\nsheet.getCell(3,1).text(\"Age\");\r\nsheet.getCell(4,1).text(\"Gender\");\r\nsheet.getCell(5,1).text(\"Address.Postcode\");\r\nsheet.addSpan(1, 1, 1, 2);\r\nsheet.getRange(1, 1, 1, 2).text(\"Person Card\")\r\nsheet.setColumnWidth(1, 120);\r\nsheet.setColumnWidth(2, 120);\r\nsheet.getRange(1, 1, 1, 2).backColor(\"rgb(20, 140, 1218)\")\r\nsheet.getRange(1, 1, 1, 2).foreColor(\"rgb(255, 255, 255)\")\r\nsheet.getRange(2, 1, 4, 1).backColor(\"rgb(169, 238, 243)\")\r\nsheet.getRange(2, 1, 4, 1).foreColor(\"rgb(255, 255, 255)\")\r\nsheet.getRange(2, 2, 4, 1).backColor(\"rgb(247, 197, 113)\")\r\nsheet.getRange(1, 1, 5, 2).setBorder(new GC.Spread.Sheets.LineBorder(\"Black\", GC.Spread.Sheets.LineStyle.thin), {\r\n    all: true\r\n});\r\nsheet.getRange(2, 1, 4, 2).setBorder(new GC.Spread.Sheets.LineBorder(\"Black\", GC.Spread.Sheets.LineStyle.dotted), {\r\n    inside: true\r\n});\r\nsheet.getRange(1, 1, 1, 2).hAlign(GC.Spread.Sheets.HorizontalAlign.center);\r\n"
            }]
        }]
    },
    "demos": {
        "Workbook": {
            "title": "통합 문서"
        },
        "initializeSpread": {
            "title": "Spread 초기화"
        },
        "spreadSheet": {
            "title": "스프레드시트 보기"
        },
        "tabStrip": {
            "title": "연속 탭"
        },
        "scrollbar": {
            "title": "스크롤 막대"
        },
        "spreadBackground": {
            "title": "배경 보기"
        },
        "spreadPaint": {
            "title": "Spread 칠하기"
        },
        "spreadEvents": {
            "title": "이벤트"
        },
        "spreadFromJSONToJSON": {
            "title": "JSON 직렬화"
        },
        "dataSourceSerialize": {
            "title": "데이터 원본 직렬화"
        },
        "customItemSerialize": {
            "title": "사용자 정의 항목 직렬화"
        },
        "spreadHitTest": {
            "title": "적중 테스트"
        },
        "Worksheet": {
            "title": "워크시트"
        },
        "initializeSheet": {
            "title": "시트 초기화"
        },
        "bordersAndGridlines": {
            "title": "테두리 및 눈금선"
        },
        "sheetVisible": {
            "title": "표시 여부"
        },
        "sheetZoom": {
            "title": "확대/축소"
        },
        "sheetHeader": {
            "title": "헤더"
        },
        "rowsAndColumns": {
            "title": "행 및 열"
        },
        "cellBasic": {
            "title": "셀 기본"
        },
        "cellSpan": {
            "title": "셀 병합"
        },
        "frozenLineAndViewport": {
            "title": "고정 꺾은선형 및 Viewport"
        },
        "getSetData": {
            "title": "데이터"
        },
        "formula": {
            "title": "수식"
        },
        "font": {
            "title": "글꼴"
        },
        "style": {
            "title": "스타일"
        },
        "cellPaddingAndLabel": {
            "title": "셀 안쪽 여백 및 레이블"
        },
        "selection": {
            "title": "선택"
        },
        "sheetActions": {
            "title": "작업"
        },
        "changeValueByActions": {
            "title": "업데이트 작업"
        },
        "customAction": {
            "title": "사용자 정의 작업"
        },
        "protection": {
            "title": "보호"
        },
        "sheetEvents": {
            "title": "이벤트"
        },
        "sheetPaint": {
            "title": "그림"
        },
        "outlineColumn": {
            "title": "개요 열"
        },
        "Calculation": {
            "title": "계산"
        },
        "basicFunctions": {
            "title": "기본 함수"
        },
        "indirect": {
            "title": "Indirect 함수"
        },
        "functionWildcard": {
            "title": "함수 와일드카드"
        },
        "customFunctions": {
            "title": "사용자 정의 함수"
        },
        "asyncFunction": {
            "title": "비동기 함수"
        },
        "basicArrayFormula": {
            "title": "배열 수식"
        },
        "arrayFormulaUsage": {
            "title": "배열 수식 사용"
        },
        "DataBinding": {
            "title": "데이터 바인딩"
        },
        "sheetLevelBinding": {
            "title": "시트"
        },
        "cellLevelBinding": {
            "title": "셀"
        },
        "tableBinding": {
            "title": "표"
        },
        "Edit": {
            "title": "편집"
        },
        "navigationActions": {
            "title": "탐색"
        },
        "dirtyItems": {
            "title": "더티 항목"
        },
        "copyPasteExcelStyle": {
            "title": "Excel 스타일 복사하여 붙여넣기"
        },
        "pasteExtendRange": {
            "title": "확장된 범위 붙여넣기"
        },
        "copyPasteEnhancement": {
            "title": "향상된 기능 복사하여 붙여넣기"
        },
        "quotePrefix": {
            "title": "따옴표 접두사"
        },
        "Formatter": {
            "title": "포맷터"
        },
        "basicFormatter": {
            "title": "소개"
        },
        "customFormatter": {
            "title": "사용자 정의 포맷터"
        },
        "accountingFormatter": {
            "title": "회계 포맷터"
        },
        "CellType": {
            "title": "셀 유형"
        },
        "basicCellType": {
            "title": "소개"
        },
        "buttonCellType": {
            "title": "단추"
        },
        "checkBoxCellType": {
            "title": "확인란"
        },
        "comboBoxCellType": {
            "title": "콤보 상자"
        },
        "hyperLinkCellType": {
            "title": "하이퍼링크"
        },
        "customCellType": {
            "title": "사용자 정의"
        },
        "customHeaderCellType": {
            "title": "사용자 정의 머리글"
        },
        "Shape": {
            "title": "도형"
        },
        "basicShape": {
            "title": "소개"
        },
        "autoshape": {
            "title": "기본 도형"
        },
        "connectorShape": {
            "title": "연결선 도형"
        },
        "groupShape": {
            "title": "그룹 도형"
        },
        "customShape": {
            "title": "사용자 정의 도형"
        },
        "shapeWithFormula": {
            "title": "수식 포함 도형"
        },
        "Chart": {
            "title": "차트"
        },
        "basicChart": {
            "title": "소개"
        },
        "columnChart": {
            "title": "세로 막대형 차트"
        },
        "lineChart": {
            "title": "꺾은선형 차트"
        },
        "pieChart": {
            "title": "원형 차트"
        },
        "areaChart": {
            "title": "영역형 차트"
        },
        "barChart": {
            "title": "막대형 차트"
        },
        "scatterChart": {
            "title": "XY 분산형 차트"
        },
        "stockChart": {
            "title": "주식형 차트"
        },
        "comboChart": {
            "title": "콤보 차트"
        },
        "radarChart": {
            "title": "방사형 차트"
        },
        "sunburstChart": {
            "title": "선버스트 차트"
        },
        "treemapChart": {
            "title": "트리맵 차트"
        },
        "Table": {
            "title": "표"
        },
        "basicTable": {
            "title": "소개"
        },
        "customTable": {
            "title": "사용자 정의 표"
        },
        "tableStyle": {
            "title": "스타일"
        },
        "ConditionalFormat": {
            "title": "조건부 서식"
        },
        "basicConditionalFormat": {
            "title": "소개"
        },
        "conditionalRules": {
            "title": "조건부 규칙"
        },
        "DataValidation": {
            "title": "데이터 유효성 검사"
        },
        "basicDataValidator": {
            "title": "소개"
        },
        "customDataValidator": {
            "title": "사용자 정의 유효성 검사"
        },
        "Fill": {
            "title": "채우기"
        },
        "basicFill": {
            "title": "소개"
        },
        "customFill": {
            "title": "사용자 정의 채우기"
        },
        "Filter": {
            "title": "필터"
        },
        "basicFilter": {
            "title": "소개"
        },
        "filterDialog": {
            "title": "필터 대화 상자"
        },
        "filterAction": {
            "title": "필터 작업"
        },
        "customFilter": {
            "title": "사용자 정의 필터"
        },
        "Outline": {
            "title": "윤곽선"
        },
        "basicGroup": {
            "title": "소개"
        },
        "customizeGroup": {
            "title": "사용자 정의"
        },
        "groupAppearance": {
            "title": "외관"
        },
        "Comments": {
            "title": "메모"
        },
        "basicComment": {
            "title": "소개"
        },
        "commentSetting": {
            "title": "설정"
        },
        "commentActions": {
            "title": "작업"
        },
        "commentEvent": {
            "title": "이벤트"
        },
        "Sparkline": {
            "title": "스파크라인"
        },
        "basicSparkline": {
            "title": "소개"
        },
        "customSparkline": {
            "title": "사용자 정의 스파크라인"
        },
        "sparklineSetting": {
            "title": "설정"
        },
        "cascadeSparkline": {
            "title": "계단식 배열"
        },
        "boxplotSparkline": {
            "title": "상자 그림"
        },
        "bulletSparkline": {
            "title": "글머리 기호"
        },
        "hbarAndVbarSparkline": {
            "title": "HBar 및 VBar"
        },
        "paretoSparkline": {
            "title": "파레토"
        },
        "pieSparkline": {
            "title": "원형"
        },
        "areaSparkline": {
            "title": "영역"
        },
        "scatterSparkline": {
            "title": "분산형"
        },
        "spreadSparkline": {
            "title": "스프레드"
        },
        "stackedSparkline": {
            "title": "누적형"
        },
        "variSparkline": {
            "title": "변수"
        },
        "compatibleSparkline": {
            "title": "호환 가능"
        },
        "customSparklineEx": {
            "title": "사용자 정의 스파크라인 예"
        },
        "monthSparkline": {
            "title": "월"
        },
        "yearSparkline": {
            "title": "년"
        },
        "RichText": {
            "title": "서식 있는 텍스트"
        },
        "basicRichText": {
            "title": "소개"
        },
        "barCode": {
            "title": "바코드"
        },
        "basicBarCode": {
            "title": "소개"
        },
        "qrCode": {
            "title": "QR 코드"
        },
        "dataMatrix": {
            "title": "Data Matrix"
        },
        "pdf417": {
            "title": "PDF417"
        },
        "ean13": {
            "title": "EAN13"
        },
        "ean8": {
            "title": "EAN8"
        },
        "codabar": {
            "title": "Codabar"
        },
        "code39": {
            "title": "CODE39"
        },
        "code93": {
            "title": "CODE93"
        },
        "code128": {
            "title": "CODE128"
        },
        "gs1128": {
            "title": "GS1-128"
        },
        "code49": {
            "title": "CODE49"
        },
        "Search": {
            "title": "검색"
        },
        "basicSearch": {
            "title": "소개"
        },
        "FloatingObject": {
            "title": "움직이는 개체"
        },
        "basicFloatingObject": {
            "title": "소개"
        },
        "customizeFloatingObject": {
            "title": "사용자 정의"
        },
        "picture": {
            "title": "그림"
        },
        "fixedPosition": {
            "title": "고정 위치"
        },
        "floatingObjectAction": {
            "title": "작업"
        },
        "floatingObjectEvent": {
            "title": "이벤트"
        },
        "NameInfo": {
            "title": "이름 정보"
        },
        "addCustomName": {
            "title": "소개"
        },
        "Slicer": {
            "title": "슬라이서"
        },
        "slicerIntroduction": {
            "title": "소개"
        },
        "slicerSetting": {
            "title": "설정"
        },
        "generalSlicerData": {
            "title": "일반 슬라이서 데이터"
        },
        "tableSlicerData": {
            "title": "표 슬라이서 데이터"
        },
        "itemSlicer": {
            "title": "항목 슬라이서"
        },
        "chartSlicer": {
            "title": "차트 슬라이서"
        },
        "treeSlicer": {
            "title": "트리 슬라이서"
        },
        "aggregationSlicer": {
            "title": "집계 슬라이서"
        },
        "studentSlicer": {
            "title": "학생 슬라이서"
        },
        "amazonSlicer": {
            "title": "Amazon 슬라이서"
        },
        "FormulaTextBox": {
            "title": "수식 텍스트 상자"
        },
        "basicFormulaTextBox": {
            "title": "소개"
        },
        "rangeSelect": {
            "title": "범위 선택"
        },
        "TagAPI": {
            "title": "태그"
        },
        "tagBasic": {
            "title": "소개"
        },
        "tagAction": {
            "title": "작업"
        },
        "tagSearch": {
            "title": "검색"
        },
        "ClientSideExcelIO": {
            "title": "Excel 가져오기 내보내기"
        },
        "ExcelIO": {
            "title": "Excel IO"
        },
        "Pdf": {
            "title": "PDF 내보내기"
        },
        "basicPdf": {
            "title": "소개"
        },
        "customPdf": {
            "title": "사용자 정의 PDF 내보내기"
        },
        "customFontExportPdf": {
            "title": "사용자 정의 글꼴 PDF 내보내기"
        },
        "Print": {
            "title": "인쇄"
        },
        "basicPrint": {
            "title": "소개"
        },
        "customPrint": {
            "title": "사용자 정의 인쇄"
        },
        "ContextMenu": {
            "title": "상황에 맞는 메뉴"
        },
        "basicContextMenu": {
            "title": "소개"
        },
        "customMenuView": {
            "title": "사용자 정의 메뉴 보기"
        },
        "extendContextMenu": {
            "title": "확장된 상황에 맞는 메뉴"
        },
        "Touch": {
            "title": "터치"
        },
        "basicTouch": {
            "title": "소개"
        },
        "touchToolStrip": {
            "title": "터치 도구 상자"
        },
        "Theme": {
            "title": "테마"
        },
        "documentTheme": {
            "title": "문서 테마"
        },
        "externalTheme": {
            "title": "외부 테마"
        },
        "spreadTheme": {
            "title": "Spread 테마"
        },
        "Culture": {
            "title": "문화권"
        },
        "localization": {
            "title": "지역화"
        },
        "globalization": {
            "title": "세계화"
        },
        "BusinessDashboard": {
            "title": "비지니스 대시보드"
        },
        "financialKPIs": {
            "title": "재무 KPIs"
        },
        "AgingReport": {
            "title": "에이징 보고서"
        },
        "incomeStatement": {
            "title": "손익계산서"
        },
        "expensebudget": {
            "title": "비용 예산"
        },
        "taxform": {
            "title": "1040 세금 양식"
        },
        "gradebookDashboard": {
            "title": "성적표 대시보드"
        },
        "cookbook": {
            "title": "쿡북"
        },
        "CostOfGoodsSold": {
            "title": "판매 제품 원가"
        },
        "whatIfAnalysis": {
            "title": "가정 분석 템플릿"
        },
        "shapeOperationWorkflow": {
            "title": "도형 작업 워크플로"
        }
    }
};


// WEBPACK FOOTER //
// ./i18n/en.js